import _extends from 'babel-runtime/helpers/extends';

import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';

export default {
  components: {},
  props: {
    navIndex: String
  },
  data: function data() {
    return {};
  },

  computed: _extends({}, mapGetters(['logo', 'crm'])),
  mounted: function mounted() {},

  methods: {
    enterHome: function enterHome() {
      this.$router.replace({
        path: '/'
      });
    },
    enterLogin: function enterLogin() {
      var _this = this;

      this.$confirm('退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var loading = Loading.service({
          target: document.getElementById('#app')
        });
        _this.$store.dispatch('LogOut').then(function () {
          loading.close();
          location.reload();
        }).catch(function () {
          loading.close();
          location.reload();
        });
      }).catch(function () {});
    },


    /**
     * 有客户权限点击logo 进入仪表盘
     */
    enterCustoemBoard: function enterCustoemBoard() {
      if (this.crm) {
        this.$router.push('/crm/workbench');
      }
    }
  }
};